import { AxiosRequestConfig } from 'axios'

import { CreateTagPayload, GetTotalUsersWithAllTagsPayload, UpdateTagData } from './types'

const getTags = (): AxiosRequestConfig => ({
  url: '/tags',
  method: 'GET',
})

const getActiveTags = (): AxiosRequestConfig => ({
  url: '/tags/active',
  method: 'GET',
})

const createTag = (tag: CreateTagPayload): AxiosRequestConfig => {
  const { title, description, active, file, group } = tag

  const formData = new FormData()
  formData.append('title', title)
  formData.append('description', description)
  formData.append('active', String(active))
  if (group) formData.append('group', group)

  if (file) {
    formData.append('file', file)
  }

  return {
    url: '/tags',
    method: 'POST',
    data: formData,
  }
}

const updateTag = (data: UpdateTagData): AxiosRequestConfig => {
  const payload = new FormData()
  const { title, description, active, file, timeFrom, timeTo } = data.payload

  if (title) payload.append('title', title)
  if (description) payload.append('description', description)
  if (active !== undefined) payload.append('active', active.toString())
  if (file) payload.append('file', file)
  if (timeFrom) payload.append('timeFrom', timeFrom)
  if (timeTo) payload.append('timeTo', timeTo)

  return {
    url: `/tags/${data.id}`,
    method: 'PUT',
    data: payload,
  }
}

const deleteTag = (id: number): AxiosRequestConfig => ({
  url: `/tags/${id}`,
  method: 'DELETE',
})

const getTotalUsersWithAllTags = (data: GetTotalUsersWithAllTagsPayload): AxiosRequestConfig => {
  return {
    url: `/tags/total-users`,
    method: 'POST',
    data: { tags: data.tagIds.toString() },
  }
}

export { getTags, createTag, updateTag, deleteTag, getActiveTags, getTotalUsersWithAllTags }
